import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColumnStart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ColumnEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
export const ColumnSpaceAround = styled.div`
  display: flex;
  flex-direction: column;
`;



// WEBPACK FOOTER //
// ./src/components/Common/Column.js